module.exports = __webpack_public_path__ + "static/2-6847895d8f4ce33df0f5b2e1d775776e.jpg";